import { CodeHighlighterTheme } from "@/utils/CodeHighlighter";
import { ThemeMeta } from ".";

import "./pure.css";

export default <ThemeMeta>{
  highlight: CodeHighlighterTheme.Tomorrow,
  editor: "tomorrow"
};
